import { State } from "@/services/geographical.service";

export interface Location {
  id: number | null;
  name: string;
  address1: string;
  address2?: string;
  city: string;
  state_id: number | null;
  country_id: string | null;
  zip: string;
  phone?: string;
  website?: any;
  fax?: any;
  email?: any;
  currency: string;
  timezone_id: number | null;
  location_type: string;
  license_type: string;
  limit_config?: any;
  license_number: string;
  user_id?: number | null;
  _method?: string;
  default_lang?: string;
  date_format: string;
  traceability_system_id: string | null;
  state?: State | null;
  dea?: string | null;
}

export const locationDefault: Location = {
  id: null,
  user_id: null,
  name: "",
  default_lang: "",
  date_format: "",
  address1: "",
  address2: "",
  phone: "",
  fax: "",
  website: "",
  country_id: null,
  city: "",
  state_id: null,
  zip: "",
  location_type: "",
  license_type: "",
  license_number: "",
  currency: "",
  timezone_id: null,
  traceability_system_id: null,
  state: null,
  dea: ""
};
